<template>
  <div>
    <div class="row">
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
        <h6 class="mb-0 v-no-border-radius">
          CHECAGEM DE MEDICAMENTOS - MEDICAMENTOS MAIS UTILIZADOS
        </h6>
        <small>Gráfico abaixo mostra os 10 medicamentos mais utilizados.</small>
      </div>
      <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12 pt-0 pb-0">
        <v-text-field
          @input="retrieve"
          v-model="init"
          type="date"
          label="Data inicial"
          outlined
          dense
        />
      </div>
      <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-12 pt-0 pb-0">
        <v-text-field
          @input="retrieve"
          v-model="end"
          type="date"
          label="Data final"
          outlined
          dense
        />
      </div>
    </div>
    <div
      class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 v-clean p-5"
      v-if="items.length == 1 && errors.length == 0"
    >
      <h6 class="text-center upper-text worksansr">Sem resultados!</h6>
    </div>
    <div
      v-if="errors.length > 0"
      class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0"
    >
      <ErrorsMessages :errors="errors" />
    </div>
    <b-overlay
      :show="loading"
      opacity="0.99"
      class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 card"
      v-if="items.length > 1"
    >
      <GChart
        v-if="items.length > 1"
        :settings="{ packages: ['bar'] }"
        :data="items"
        :options="chartOptions"
        :createChart="(el, google) => new google.charts.Bar(el)"
      />
    </b-overlay>
  </div>
</template>

<script>
import { GChart } from "vue-google-charts";

import routes from "../../../../routes";

import ErrorsMessages from "../../../Components/ErrorsMessages";

import api from "../../../../services/api";

import moment from "moment";

export default {
  name: "Chart",
  components: {
    GChart,
    ErrorsMessages,
  },
  data() {
    return {
      chartsLib: null,
      items: [["MEDICAMENTOS", "QUANTIDADE"]],
      init: moment().format("YYYY-MM-DD"),
      end: moment().format("YYYY-MM-DD"),
      chartOptions: {
        bars: "horizontal",
        colors: ["#1B9E77"],
        legend: { position: "none" },
      },
      errors: [],
      loading: false,
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    async retrieve() {
      try {
        this.loading = true;

        this.items = [["MEDICAMENTOS", "QUANTIDADE"]];

        const { id } = routes.history.current.params;

        const { init, end } = this;

        let params = { resident_id: id, init, end };

        const response = await api.get(
          "/rest-home/resident/cheers-graphics/most-used-medicines",
          {
            params,
          }
        );

        const { medicines, error, errors } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          for (let medicine of medicines) {
            this.items.push([medicine.name, medicine.total]);
          }
          this.errors = [];
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style></style>
